import PropTypes from 'prop-types';
import React from 'react';
import ImageLoader from '../image-loader';
import styles from './profile-cover.scss';

const getStyle = src => ({
  backgroundImage: src && `url(${src})`,
});

const renderOverlay = isLoading => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <ImageLoader type="medium"/>
    </div>
  );
};

const ProfileCover = ({ src, isLoading }) =>
  <div className={styles.container} style={getStyle(src)}>
    {renderOverlay(isLoading)}
  </div>;

ProfileCover.propTypes = {
  src: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ProfileCover;



// WEBPACK FOOTER //
// ./app/components/profile-cover/profile-cover.js